import { useQuery } from "react-query";
import { DataPribadiResponse } from "../../../../models/DataPribadi";
import apiClient from "../../../apiClient";


import queryWrapper from "../../queryWrapper";

export const dataPribadiKey = "data-pribadi-key";

export async function dataPribadi(): Promise<DataPribadiResponse> {
  const res = await apiClient.get(`/DataPribadi`);
  return res.data[0];
}

export default function useFetchDataPribadi() {
  return useQuery([dataPribadiKey], queryWrapper(dataPribadi));
}
